import { Box, Button, Grid, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { ARROW, BASEURL } from '../../../../constants/Common';
import FloatingButton from '../../helpdesk/FloatingButton';
import { toast } from 'react-toastify';
import axios from 'axios';
import { TrainingResource } from './TrainingRegister';
import { useEffect, useState } from 'react';

function TrainingPage() {
  const navigate = useNavigate();
  const [trainingResources, setTrainingResources] = useState<TrainingResource[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [registeredCourses, setRegisteredCourses] = useState<{ [key: string]: boolean }>({});

  const UserId = JSON.parse(localStorage.getItem('authData') || 'null');
  const email = JSON.parse(localStorage.getItem('email') || 'null');

  const fetchTrainingResources = async () => {
    try {
      const response = await axios.get(BASEURL + `/trainingresources/${UserId}/`);
      const trainingResourceData = response.data;
      console.log('trainingresource', trainingResourceData);

      if (trainingResourceData.training_resources && trainingResourceData.training_resources.length > 0) {
        const resources = trainingResourceData.training_resources.map((resource: TrainingResource) => ({
          ...resource,
          user: trainingResourceData.user,
        }));
        setTrainingResources(resources);

        // Check which courses the user is already registered for
        const userCourses: { [key: string]: boolean } = {};
        resources.forEach((resource: { user: { id: number }; type_of_course: string }) => {
          if (resource.user.id === UserId) {
            userCourses[resource.type_of_course] = true;
          }
        });
        setRegisteredCourses(userCourses);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching training resource:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainingResources();
  }, []);

  const handleRegister = async (planname: string) => {
    try {
      if (registeredCourses[planname]) {
        navigate('/trainingresource',{
          state: { Planname:planname },
        });
      } else {
        const url_create = BASEURL + '/trainingresources/create/';
        await axios.post(url_create, {
          user_id: UserId,
          type_of_course: planname,
          email: email
        }, {
          headers: { 'Content-Type': 'application/json' },
        });
        toast.success('Training resource registered successfully');
        setRegisteredCourses((prev) => ({ ...prev, [planname]: true }));
        navigate('/trainingresource',{
          state: { Planname:planname },
        });
      }
    } catch (error) {
      toast.error('Error creating training resource');
    }
  };

  return (
    <Box sx={{ mt: '-60px' }}>
      <Box>
        <Typography variant='h6' gutterBottom>
          <Link to={'/usersupporthome'}>User Support</Link> {ARROW} Demo Videos
        </Typography>
        <h4 style={{ textAlign: 'center', textDecoration: 'underline' }}>
          Schedule a free Training
        </h4>
        <Grid>
          <Typography>
            Our Basic and Advanced Training provides you most popular features.
            Take it a step further and schedule a free tailored training to your
            company needs.
          </Typography>
        </Grid>

        <Grid sx={{ mt: "50px" }}>
          <Typography>
            <strong>Basic Training </strong>goes over the fundamentals of using Project
            management. We will cover create Activity, schedule management and
            much more. At the end of the session we will answer your questions.
          </Typography>
        </Grid>

        <Grid sx={{ mt: "50px" }}>
          <Typography>
            <strong>Advanced Training</strong> delves deeper into the sophisticated features of our project management tools. We will explore advanced scheduling techniques,
            tracking project progress in detail, and custom reporting.
          </Typography>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <h4>Basic Training</h4>
            <Button
              variant='contained'
              onClick={() => handleRegister('Basic')}
            >
              {registeredCourses['Basic'] ? 'Registered' : 'Register'}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <h4>Advanced Training</h4>
            <Button
              variant='contained'
              onClick={() => handleRegister('Advanced')}
            >
              {registeredCourses['Advanced'] ? 'Registered' : 'Register'}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <FloatingButton />
    </Box>
  );
}

export default TrainingPage;
